import React from "react";

class RatesDashboardHeatMapLegend extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="RatesDashboardHeatMapLegend">
        <div className="colors">
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[6] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[5] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[4] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[3] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[2] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[1] }}
          ></div>
          <div
            className="cell"
            style={{ backgroundColor: this.props.heatMapColors[0] }}
          ></div>
        </div>
        <div className="labels">
          <div className="label">{I18n.t("behind")}</div>
          <div className="label">{I18n.t("on_pace")}</div>
          <div className="label">{I18n.t("ahead")}</div>
        </div>
      </div>
    );
  }
}

export default RatesDashboardHeatMapLegend;
